import {
    ShoppingCart,
    BarChart3,
    Wallet,
    CalendarDays,
    FileText,
    PieChart,
    JapaneseYen,
    Wrench,
} from "lucide-react";

const capabilities = [
    {
        Icon: ShoppingCart,
        title: "受発注管理",
        body: "受注から発注、納品までを一元管理。ミスや漏れを防止。",
    },
    {
        Icon: BarChart3,
        title: "売上管理",
        body: "売上の記録・分析を自動化。リアルタイムで状況を把握。",
    },
    {
        Icon: Wallet,
        title: "経費管理",
        body: "経費の申請・承認・集計をスムーズに。無駄を見える化。",
    },
    {
        Icon: CalendarDays,
        title: "シフト管理",
        body: "シフト作成や希望申請をラクに。人員配置も最適化。",
    },
    {
        Icon: FileText,
        title: "請求書作成",
        body: "請求書の作成・送付を自動化。入金消込もかんたん。",
    },
    {
        Icon: PieChart,
        title: "データ集計",
        body: "各種データを自動で集計・可視化。レポート作成の手間を削減。",
    },
    {
        Icon: JapaneseYen,
        title: "入金管理",
        body: "入金の確認・消込・督促まで一元管理。キャッシュフロー改善。",
    },
    {
        Icon: Wrench,
        title: "社内ツール開発",
        body: "業務に合わせたオリジナルの社内ツールを開発。",
    },
];

export default function Capabilities() {
    return (
        <section
            id="capabilities"
            data-testid="capabilities-section"
            className="relative py-20 sm:py-24 bg-white"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="text-center max-w-3xl mx-auto mb-12">
                    <h2
                        data-testid="capabilities-title"
                        className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F2A23] leading-tight"
                    >
                        毎日の業務を、ひとつずつ
                        <span className="text-[#5A9C3A]">ラク</span>
                        に。
                    </h2>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
                    {capabilities.map((c, idx) => (
                        <div
                            key={c.title}
                            data-testid={`capability-card-${idx}`}
                            className="rounded-2xl bg-white border border-[#E6EFD8] shadow-soft p-5 sm:p-6 hover:-translate-y-1 hover:shadow-soft-lg transition-all duration-300"
                        >
                            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#E6F2D6] text-[#5A9C3A]">
                                <c.Icon size={26} strokeWidth={2.25} />
                            </div>
                            <h3 className="mt-4 text-lg sm:text-xl font-extrabold text-[#1F2A23] leading-tight">
                                {c.title}
                            </h3>
                            <p className="mt-2 text-xs sm:text-sm text-[#5C6B5E] leading-relaxed">
                                {c.body}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
